import * as D from './deps';
import ComscoreWatchers from './sagas/watchers';

export default D.createDomainModule({
  name: 'comscore',
  actions: null,
  reducer: null,
  constants: null,
  selectors: null,
  components: {},
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers(ComscoreWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
